import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import { getConfig, base64ToBlob } from './utils/common'

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = getConfig("SUCCESS_API");

const responseBody = res => JSON.parse(res.text)

let token = null;

const getSessionInfo = () => {
  return { 
            token: window.sessionStorage.getItem('sct'),
            companyNm: window.sessionStorage.getItem('companyNm'),
            userId: window.sessionStorage.getItem('userId'),
            userNm: window.sessionStorage.getItem('userNm'),
            registYn: window.sessionStorage.getItem('registYn'),
            scrapYn: window.sessionStorage.getItem('scrapYn'),
            isApp: window.sessionStorage.getItem('app')
        }
}

const tokenPlugin = req => {
  token = window.sessionStorage.getItem('sct');
  if (token) {
    req.set('access_token', token);
  }
} 

const requests = {
  del: (url, body) =>
    superagent.del(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  get: (url, body) =>
    superagent.get(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  put: (url, body) => 
    superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody),
  post: (url, body) =>{
    if(!body.files){
      return superagent.post(`${API_ROOT}${url}`, body).set('Content-Type', 'application/x-www-form-urlencoded').use(tokenPlugin).then(responseBody)
    }else{
      // 파일업로드
      const files = body.files;
      delete body.files;
      
      let keys = Object.keys(body);
      for(let i=0; i<keys.length; i++){
        if(body[keys[i]] === null) delete body[keys[i]];
      }
            
      const req=superagent.post(`${API_ROOT}${url}`).field(body);

      keys = Object.keys(files);
      for(let i=0; i<keys.length; i++){
        if(files[keys[i]]){
          let base64 = files[keys[i]].replace("data:image/jpeg;base64,", "");
          base64 = base64.replace("data:image/png;base64,", "");
          const blob = base64ToBlob(base64);
          req.attach(keys[i], blob, new Date().getTime()+".jpg")
        }
      }

      return req.use(tokenPlugin).then(responseBody);
    }   
  },
  postbody: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody)
}; 

const Common = {  
  searchCodeList: parentCd =>
    requests.get('/common/code/search', { parentCd }),
  loadLastDate: () =>
    requests.get('/service/scrap/lastdate'),
  updatePushKey: (uuid, pushId) => 
    requests.put('/pushKey', { uuid, pushId }),
  agency: parentCd =>
    requests.get('/common/agency/list', { parentCd }),
  getBusinessList: () =>
    requests.get('/common/business/kind')
}

// 인증
const Auth = {
  login: (userId, userPwd) =>
    requests.get('/member/login', { userId, userPwd}),
  memberJoin: params =>
    requests.post('/member/join', params),

  // 작업은 아직 안한것
  memberCheckId: userId => 
    requests.get('/member/check/id', { userId }),

  findId: params => 
    requests.get('/member/find/id', params),
  findPasswd: params => 
    requests.put('/member/find/pass', params),

  // 아래 제거될 항목
  current: () =>
    requests.get('/mypage/member'),
  loginGoogle: (name, id, email) => 
    requests.get('/member/login/g-proc', { name, id, email }),  
  loginFacebook: (name, id, email) => 
    requests.get('/member/login/f-proc', { name, id, email }),  
  loginKakao: access_token => 
    requests.get('/member/login/k-proc', { access_token }),  
  loginNaver: access_token => 
    requests.get('/member/login/na-proc', { access_token }),    

}

// 전표입력
const Slip = {
  getList: params =>
    requests.get('/financial/slip', params),
  getDetail: params =>
    requests.get('/financial/slip/' + params.seq),
  getDetailMethod: params =>
    requests.get('/financial/slip/' + params.seq + "/method"),
  getTransCateList: params =>
    requests.get('/financial/transCateList', params),
  getMethodCateList: params =>
    requests.get('/financial/methodList', params),
  insertData: params => 
    requests.post('/financial/slip', params),
  updateData: params => 
    requests.post('/financial/slip/' + params.seq, params),
  loadimage: params => 
    requests.get('/financial/receipt', params),
  getCountReady: () => 
    requests.get('/financial/slip/count/ready'),
  deleteData: params => 
    requests.del('/financial/slip', params),
  getDetailScrap: params => 
    requests.get(`/financial/scrap/${params.kind}/${params.seq}`),
  insertTransAutoScrap: params => 
    requests.post(`/financial/scrap/${params.readyCd}/${params.seq}`, params),
  getListSlip: params =>
    requests.get('/financial/slip/remain', params),
  insertRemainData: params => 
    requests.post('/financial/slip/remain', params),
  getRemainDetail: params =>
    requests.get(`/financial/slip/remain/${params.seq}`)
}


const MyInfo = {
  updateMember: (field, params) => {
    requests.put('/info/admin/' + field, params)
  } ,    
  updateStartday: day => 
    requests.get('/basic/changeDate', {value: day}),
  updateMemberLeave: (params) => 
    requests.del('/member/leave', {params}),
  getAdminInfo: () => 
    requests.get('/info/admin'),  
  getGoogleInfo: () =>
    requests.get('/info/google-drive'),  
  getTicketLast: kind =>
    requests.get('/info/ticket/last', {kind}),  
  updateAcademySimple: params =>
    requests.put('/info/company/simple', params)    
}


const Main = {
  getMainInfo: (sDate, compareSDate, compareEDate) => 
    requests.get('/main/current', {sDate, compareSDate, compareEDate}),
  getCertifyLinkData: () => 
    requests.get('/service/scrap/link')   
}

const Scrap = {
  infos: () =>
    requests.get('/service/scrap/infos'),
  insertScrapLog: params => 
    requests.post('/service/scrap/log', {...params}),
  saveScrapData: (url, params) => 
    requests.postbody(url, {...params})
}






// 아래 제거될 항목

// 장부
const Book = {
  self: (text, page, rows) => 
    requests.get('/mypage/notes/self', { text, page, rows }),    
  connecting: (text, page, rows) => 
    requests.get('/mypage/notes/connecting', { text, page, rows }),
  all: (text, page, rows) => 
    requests.get('/mypage/notes/all', { text, page, rows }),
  send: () => 
    requests.get('/mypage/connection/send'),
  receive: () => 
    requests.get('/mypage/connection/receive'),    
  updateSend: (mlr_seq, status) => 
    requests.put('/mypage/connection/send', {mlr_seq, status}),
  updateReceive: (mlr_seq, bi_seq, status) => 
    requests.put('/mypage/connection/receive', {mlr_seq, bi_seq, status}),
  enter: (bi_seq, kind) => requests.get('/tokens/note', { bi_seq, kind }),
  connectionAble: q => 
    requests.get('/mypage/connection/able', { q }),
  postMypageConnectionSend: (bi_seq, message) => 
    requests.post('/mypage/connection/send', { bi_seq, message }),
  addBook: (kind, title) => 
    requests.post('/mypage/note/new', { kind, title })
}

//재무보고서
const Financial = {
  financialReport: params =>
    requests.get('/financial/financialReport', {...params})
  , assetDebtReport: params =>
    requests.get('/financial/assetDebtReport', {...params})
  , checkRatioReport: params =>
    requests.get('/financial/statistics/financialRatio', {...params})
  , householdReportMobile: (params, kind) =>
    requests.get('/financial/statistics/m/household', {...params, kind})
  , totalReportMobile: (params, kind) =>
    requests.get('/financial/assetDebtReportYear/chart', {...params, kind})
}

const Trans = {
  list: params =>
    requests.get('/trans', {...params, mode: 'X'}),   
  cate: (gubun, inout) =>
    requests.get('/trans/category', {gubun, inout}),
  bill: (tSeq) =>
    requests.get('/trans/scrap', {tSeq}),
  updateField: params =>
    requests.put('/trans/field', {...params}),
  method: () =>
    requests.get('/trans/jasan', {gubun:"method"}),
  detail: tSeq =>
    requests.get('/trans/note', { tSeq }),
  deleteTag: tl_seq =>
    requests.get('/trans/note', { tl_seq }),
  updateTrans: params =>
    requests.put('/trans', {...params}),
  insertTrans: params =>
    requests.post('/trans', {...params}),
  deleteTrans: tSeq =>
    requests.del('/trans', { tSeq })
}

const MyBook = {
  jasan: () =>
    requests.get('/financial/summary/today/jasan'),
  loan: () =>
    requests.get('/financial/summary/today/loan'),
  card: () =>
    requests.get('/financial/summary/today/card'),
  month: params =>
    requests.get('/financial/summary/month', params)
}

const Report = {
  getSummary: () =>
    requests.get('/report/summary'),
}

const Manage = {
  getManageSummary: (sDate, compareSDate, compareEDate, startDt, endDt) =>
    requests.get('/manage/summary', {sDate, compareSDate, compareEDate, startDt, endDt}),  
  getIlbo: (transDt) =>
    requests.get('/manage/ilbo', {transDt}),    
  getInout: (seq, schSDate, schEDate) =>
    requests.get('/manage/inout', {seq, schSDate, schEDate}),
}

const Tax = {
  getTaxInfos: (schYear) =>
    requests.get('/tax/infos', {schYear})
}

const Debt = {
  getDebtInfos: (sDate, eDate, kind, newSchTransType, newSchTransKind) =>
    requests.get('/debt/infos', {sDate, eDate, kind, newSchTransType, newSchTransKind})
}

const Consulting = {
  getMemberInfo: () =>
    requests.get('/consulting/info'),
    insertConsulting: (param) =>
    requests.post('/consulting/regist', param)
}

const Asset = {
  getBizNo: () =>
    requests.get('/info/bizno'),
  jasanAll: (useYn) =>
    requests.get('/info/jasan/list', {useYn}),
  insertCard: params =>
    requests.post('/info/card', {...params}),
  insertBank: params =>
    requests.post('/info/bank', {...params}),
  updateUseYn: (kind, seq, useYn) =>{
      let params = {seq, useYn};
      return requests.put('/info/use/' + kind, params)
  },
  insertEtc: params =>
    requests.post('/info/etc', {...params}),  
  updateHidden: (kind, seq, useYn) =>{
      let params = {seq, useYn};
      requests.put('/info/use/' + kind, params)
  },
  getJasan: kind =>
    requests.get('/manage/bank-card/list/' + kind),
  getJasanScrap: () =>
    requests.get('/manage/scrap/jasan'),
  summaryTodayBalance: params =>
    requests.get('/financial/summary/today/balance', params),      
  deleteJasan: (kind, seq) => 
    requests.del('/info/' + kind, {seq}),
  updateCertify: (kind, fiSeq, certifyType, fId, fPw, quickSubpw) => 
    requests.post('/service/scrap/account', {kind, fiSeq, certifyType, fId, fPw, quickSubpw}),
  jasanList: kind=> 
    requests.get('/manage/bank-card/list/' + kind)    
}


export default {
  Common,
  Auth,
  Slip,
  Main,
  MyInfo,
  Asset,
  Report,
  Manage,
  Tax,
  Debt,
  Consulting,

  Book,
  Financial,
  Trans,
  MyBook,  
  
  Scrap,
  getSessionInfo: getSessionInfo,
  setToken: _token => { 
    token = _token; 
    window.sessionStorage.setItem('sct', token);
  },
  setInfo: info => {
    var keys = Object.keys(info);
    for(let i=0; i<keys.length; i++){
      window.sessionStorage.setItem(keys[i], info[keys[i]]);
    }
  },
  clearAuth: () => {
    window.sessionStorage.removeItem('sct');
    window.sessionStorage.removeItem('companyNm');
    window.sessionStorage.removeItem('userId');
    window.sessionStorage.removeItem('userNm');
    window.sessionStorage.removeItem('registYn');
    window.sessionStorage.removeItem('scrapYn');
  }
};


// WEBPACK FOOTER //
// ./src/agent.js